<template lang="pug">
  div.garbage.organization-update
    e-form-modal(
    ref="modalForm"
    @submitModalForm="sendForm()"
      @deleteItem="deleteItem()"
        :hideDeleteButton="(fields.id ? true : false)"
    )
      div(slot="header")
        e-breadcrumbs
        h1(
          v-html="title"
        ).title
        e-form-tabs(
        v-model="tabView"
        :tabs="[{tab1: 'Общие сведения'},{tab2: 'Нормативы'},{tab3: 'Отходы'},{tab4: 'Операторы'},{routes: 'Маршруты'}]"
        )
      slot
        e-form(:formValidator="formValidator")
          // вкладка ОБЩИЕ СВЕДЕНИЯ
          div(v-show="tabView == 'tab1'")
            input(type="hidden" v-model="fields.parent_id")
            div.body
              div.col
                e-form-subtitle(text="Реквизиты")

                e-form-group(
                name="name"
                inputType="input"
                label="Полное наименование"
                  :model="fields"
                :required="true"
                tabView="tab1"
                )
                e-form-group(
                  name="short_name"
                  inputType="input"
                  label="Сокращенное наименование"
                  :model="fields"
                  tabView="tab1"
                )
                e-form-group(
                name="ogrn"
                inputType="input"
                label="ОГРН/ОГРНИП"
                  :model="fields"
                tabView="tab1"
                )
                e-form-group(
                name="inn"
                inputType="input"
                label="ИНН"
                  :model="fields"
                tabView="tab1"
                  :required="true"
                )
                e-form-group(
                name="kpp"
                inputType="input"
                label="КПП"
                  :model="fields"
                tabView="tab1"
                )
                e-form-group(
                name="okpo"
                inputType="input"
                label="ОКПО"
                  :model="fields"
                tabView="tab1"
                validationRule="number"
                )
                e-form-group(
                name="legal_address"
                inputType="address"
                label="Юридический адрес"
                :model="fields"
                tabView="tab1"
                addressIdFieldName="legal_address_id"
                :addressData="addressData"
                )
                e-form-group(
                name="status_id"
                inputType="select"
                  :required="true"
                label="Статус объекта"
                  :model="fields"
                tabView="tab1"
                  :options="statuses"
                )
                e-form-group(
                name="close_date"
                inputType="calendar"
                label="Дата закрытия"
                  :model="fields"
                tabView="tab1"
                  :disabled="fields.status_id !== notActive"
                )
              div.col
                e-form-subtitle(text="Вид деятельности по ОКВЭД")
                e-form-group(
                name="code"
                inputType="input"
                label="ОКВЭД(номер)"
                :model="fields.okved"
                validateAlias="okved.code"
                tabView="tab1"
                )
                e-form-group(
                name="name"
                inputType="input"
                label="ОКВЭД(наименование)"
                :model="fields.okved"
                validateAlias="okved.name"
                tabView="tab1"
                )
                e-form-group(
                name="business_category_id"
                inputType="select"
                label="Отношение к субъектам предпринимательства"
                  :model="fields"
                tabView="tab1"
                  :options="business_categories"
                )
                e-form-group(
                name="activity_description"
                inputType="textarea"
                label="Краткое описание деятельности"
                  :model="fields"
                tabView="tab1"
                )

                e-form-subtitle(text="Руководитель")
                e-form-group(
                name="head_position"
                inputType="input"
                label="Должность"
                  :model="fields"
                tabView="tab1"
                )
                e-form-group(
                name="head_name"
                inputType="input"
                label="ФИО"
                  :model="fields"
                tabView="tab1"
                )
                e-form-group(
                name="head_phone"
                inputType="input"
                validationRule="phone"
                label="Телефон"
                  :model="fields"
                tabView="tab1"
                )
                e-form-group(
                name="head_email"
                inputType="input"
                validationRule="email"
                label="Email"
                  :model="fields"
                tabView="tab1"
                )


              div.col
                e-form-subtitle(text="Местоположение")
                e-location(
                :formValidator="formValidator"
                :model="fields"
                name="fact_address"
                :required="true"
                :addressData="addressData"
                addressIdFieldName="fact_address_id"
                tabView="tab1"
                )

                e-form-group(
                  name="detail"
                  inputType="textarea"
                  label="Контактные данные"
                  :model="fields"
                  tabView="tab1"
                )
                e-form-group(
                  name="link"
                  inputType="url"
                  label="Сайт"
                  :model="fields"
                  tabView="tab1"
                )

                e-form-subtitle(text="Ответственный за экологию")
                e-form-group(
                name="eco_position"
                inputType="input"
                label="Должность"
                  :model="fields"
                tabView="tab1"
                )
                e-form-group(
                name="eco_name"
                inputType="input"
                label="ФИО"
                  :model="fields"
                tabView="tab1"
                )
                e-form-group(
                name="eco_phone"
                inputType="input"
                label="Телефон"
                validationRule="phone"
                  :model="fields"
                tabView="tab1"
                )
                e-form-group(
                name="eco_email"
                inputType="input"
                validationRule="email"
                label="Email"
                  :model="fields"
                tabView="tab1"
                )
                e-form-group(
                  name="photoPreview"
                  inputType="simple-file-uploader"
                  label="Фотография"
                  :model="fields"
                  tabView="tab1"
                  :uploadUrl="uploadUrl"
                  @fileUploaded="fileUploaded"
                  @fileRemoved="fileRemoved"
                  :showFilePreview="true"
                )

          // вкладка НОРМАТИВЫ
          div(v-show="tabView == 'tab2'")
            r-garbage-operation(
              :id="$route.params.id"
              tabView="tab2"
              :model="fields"
            ref="garbageOperation"
            )

          // вкладка ОТХОДЫ
          div(v-if="tabView == 'tab3'")
            garbage-table(:id="fields.id" ref="garbageTable" tabView="tab3")

          // вкладка ОПЕРАТОРЫ
          div(v-show="tabView == 'tab4'")
            operator-table(:id="fields.id" ref="operatorTable" tabView="tab4")

          // Маршруты
          div(v-if="tabView == 'routes'").routes
            routes-table(:fields="fields" :id="fields.id" ref="routesTable" tabView="routes")
</template>

<script>
  import GarbageTable from "../components/garbage-table.vue";

  import {garbage, core} from '../../../api/api-endpoints.js'
  import garbageForm from '../mixins/garbage-form.js';
  import OperatorTable from "../components/operator-table.vue";
  import RoutesTable from "../components/routes-table.vue";
  import {GARBAGE_TYPE_ORGANIZATION} from "../../../config/config";

  export default {
    components: {
      RoutesTable,
      OperatorTable,
      GarbageTable
    },
    mixins: [garbageForm],
    data () {
      return {
        tabView: 'tab1',
        fields: {
          status_id: '',
          business_category_id: '',
          latitude: '',
          longitude: '',
          garbage_source_type_id: GARBAGE_TYPE_ORGANIZATION,
          garbage_source_category_id: ''
        },
        errors: null
      }
    },
    methods: {
      getBusinessCategoriesEndpoint () {
        return core.statuses({fields: 'business_category'})
      },
      getStatusEndpoint () {
        return core.statuses({fields: 'status'})
      },
      getDeleteUrl (id) {
        return garbage.garbageDelete(id)
      },
      getUpdateOrCreateUrl () {
        return garbage.garbageUpdateOrCreate(this.$route.params.id)
      },
      getItemEndpoint (route) {
        if (!route.params.id) {
          return null
        }
        return garbage.garbage(route.params.id)
      }
    }
  }
</script>
